import apiClient from "./axiosConfig";
/**
 * 获取报考流程数据
 */
export function getProcessList() {
  return apiClient({
    url: "/interface/process/processlist",
    method: "get",
  });
}

/**
 * 获取所有报考流程及当前所处阶段
 */
export function getAllProcess() {
  return apiClient({
    url: "/interface/process/all",
    method: "get",
  });
}

/**
 * 获取职业发展信息
 */
export function getCareerInfo() {
  return apiClient({
    url: "/interface/examination/career",
    method: "get",
  });
}

/**
 * 获取女生报考专项指南
 */
export function getFemaleGuide() {
  return apiClient({
    url: "/interface/examination/female",
    method: "get",
  });
}

/**
 * 获取体检标准
 */
export function getMedicalStandard() {
  return apiClient({
    url: "/interface/examination/medical",
    method: "get",
  });
}

/**
 * 获取政审指南
 */
export function getPoliticalGuide() {
  return apiClient({
    url: "/interface/examination/political",
    method: "get",
  });
}

/**
 * 查询位次
 * @param {Object} params - 查询参数
 * @param {string} params.score - 分数
 * @param {string} [params.years='2025'] - 年份
 * @param {string} [params.type='0'] - 类型(0-物理类,1-历史类)
 */
export function getRankQuery(params) {
  return apiClient({
    url: "/interface/rank/query",
    method: "get",
    params: params,
  });
}

/**
 * 根据分数查询最新年份位次
 * @param {string} score - 分数
 * @param {string} [type='0'] - 类型(0-物理类,1-历史类，默认0物理类)
 */
export function getRankByScore(score, type = '0') {
  return apiClient({
    url: "/interface/rank/getByScore",
    method: "get",
    params: { score, type },
  });
}

/**
 * 随机获取面试题
 */
export function getRandomInterview() {
  return apiClient({
    url: "/interface/interview/random",
    method: "get",
  });
}

/**
 * 获取面试题正确答案
 * @param {Array} questionIds - 题目ID列表
 */
export function getInterviewAnswers(questionIds) {
  return apiClient({
    url: "/interface/interview/answers",
    method: "post",
    data: { questionIds },
  });
}

/**
 * AI评判面试答题
 * @param {Array} qaList - 问答列表
 */
export function evaluateInterview(qaList) {
  return apiClient({
    url: "/interface/interview/evaluate",
    method: "post",
    data: { qaList },
  });
}

/**
 * 保存面试记录
 * @param {Object} data - 保存数据
 * @param {Object} data.evaluationResult - 评判结果
 * @param {Array} data.qaList - 问答列表
 */
export function saveInterview(data) {
  return apiClient({
    url: "/interface/interview/save",
    method: "post",
    data: data,
  });
}

/**
 * 查询面试记录列表（分页）
 * @param {Object} params - 查询参数
 * @param {number} [params.pageNum=1] - 页码
 * @param {number} [params.pageSize=10] - 每页条数
 */
export function getInterviewRecords(params = {}) {
  const { pageNum = 1, pageSize = 10 } = params;
  return apiClient({
    url: "/interface/interview/records",
    method: "get",
    params: { pageNum, pageSize },
  });
}

/**
 * 查询面试记录详情
 * @param {number} id - 记录ID
 */
export function getInterviewRecordDetail(id) {
  return apiClient({
    url: `/interface/interview/record/${id}`,
    method: "get",
  });
}

/**
 * 获取在线课堂列表（分页）
 * @param {Object} params - 查询参数
 * @param {number} [params.pageNum=1] - 页码
 * @param {number} [params.pageSize=10] - 每页条数
 * @param {string} [params.title] - 标题（模糊搜索）
 */
export function getOnlineClassList(params = {}) {
  const { pageNum = 1, pageSize = 10, title = "" } = params;
  return apiClient({
    url: "/interface/onlineclass/list",
    method: "get",
    params: { pageNum, pageSize, title },
  });
}

/**
 * 获取在线课堂详情
 * @param {number} id - 在线课堂ID
 */
export function getOnlineClassDetail(id) {
  return apiClient({
    url: "/interface/onlineclass/detail",
    method: "get",
    params: { id },
  });
}
